export const employeeTids = {
    lastNameInput: 'staffWidget-employee-lastNameInput',
    firstNameInput: 'staffWidget-employee-firstNameInput',
    middleNameInput: 'staffWidget-employee-middleNameInput',
    genderRadioGroup: 'staffWidget-employee-genderRadio',
    birthdayInput: 'staffWidget-employee-birthdayInput',
    citizenshipCombobox: 'staffWidget-employee-citizenshipCombobox',
    residentStatusCombobox: 'staffWidget-employee-residentStatusCombobox',
    snilsInput: 'staffWidget-employee-snilsInput',
    innInput: 'staffWidget-employee-innInput',
    documentNumberInput: 'staffWidget-employee-documentNumberInput',
    documentTypeInput: 'staffWidget-employee-documentTypeInput',
    emailInput: 'staffWidget-employee-emailInput',
    phoneInput: 'staffWidget-employee-phoneInput',
    bankAccount: {
        banksDirectory: 'staffWidget-employee-paymentMethods-banksDirectory',
        tab: 'staffWidget-employee-paymentMethods-bankAccountTab',
        nameInput: 'staffWidget-employee-paymentMethods-bankAccount-nameInput',
        accountInput: 'staffWidget-employee-paymentMethods-bankAccount-accountInput',
        bikInput: 'staffWidget-employee-paymentMethods-bankAccount-bikInput',
    },
    organization: {
        tab: 'staffWidget-employee-paymentMethods-organizationTab',
        nameInput: 'staffWidget-employee-paymentMethods-organization-nameInput',
        bikInput: 'staffWidget-employee-paymentMethods-organization-bikInput',
        innInput: 'staffWidget-employee-paymentMethods-organization-innInput',
        kppInput: 'staffWidget-employee-paymentMethods-organization-kppInput',
        paymentAccountInput: 'staffWidget-employee-paymentMethods-organization-paymentAccountInput',
        accountInput: 'staffWidget-employee-paymentMethods-organization-accountInput',
        recipientAccountInput: 'staffWidget-employee-paymentMethods-organization-recipientAccountInput',
        kbkInput: 'staffWidget-employee-paymentMethods-organization-kbkInput',
        registrationNumber: 'staffWidget-employee-paymentMethods-organization-registrationNumber',
        registrationNumberSfr: 'staffWidget-employee-paymentMethods-organization-registrationNumber-sfr',
    },
};
export const banksDirectoryTids = {
    manualMode: 'staffWidget-banksDirectory-manualMode',
    bikInput: 'staffWidget-banksDirectory-bikInput',
    orgNameInput: 'staffWidget-banksDirectory-orgName',
};
export const reactUITids = {
    tooltip: 'Tooltip__content',
    link: 'Link__root',
    menu: 'Menu__root',
    loaderVeil: 'Loader__Veil',
    combobox: 'InputLikeText__root',
    comboboxMenuItem: 'ComboBoxMenu__item',
    comboboxNotFound: 'ComboBoxMenu__notFound',
    tab: 'Tab__root',
    input: 'Input__root',
    sidePageClose: 'SidePage__close',
};
